import { t } from 'i18next';
import { useAppDispatch } from '../redux_store/reduxStore';
import { showErrorSnackbar } from '../redux_store/slices/snackbarSlice';
import { ValidateInput } from '../utils/ValidationUtils';
import { ERROR } from '../constants/Colors';

interface ValidationProps {
  fieldName: string;
  fieldValue: string;
  formRef?: any;
  validationPattern?: RegExp | undefined;
  requiredMessage?: string | undefined;
  invalidMessage?: string | undefined;
}

const useValidation = () => {
  const dispatch = useAppDispatch();

  function validateField(props: ValidationProps): boolean {
    let isValid = true;
    if (!props?.fieldValue) {
      dispatch(
        showErrorSnackbar({
          message: `${t(props?.fieldName)} ${t(props?.requiredMessage ?? 'IS_REQUIRED')}`
        })
      );
      isValid = false;
    }

    if (props?.validationPattern && !ValidateInput(props?.validationPattern, props?.fieldValue)) {
      dispatch(
        showErrorSnackbar({
          message: `${t(props?.invalidMessage ?? 'PLEASE_ENTER_VALID')} ${t(props?.fieldName)}`
        })
      );
      isValid = false;
    }

    if (!isValid) {
      if (props?.formRef?.current) {
        //let element: any = formRef?.current.querySelector('#name');
        let element: any = props?.formRef?.current.querySelector(
          '[id="' + t(props?.fieldName) + '"]'
        );

        if (element instanceof HTMLElement) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.focus({ preventScroll: true });

          const inputContainer: any = element.closest('.MuiOutlinedInput-root');
          if (inputContainer) {
            inputContainer.classList.add('Mui-focused');
            const notchedOutline: any = inputContainer.querySelector(
              '.MuiOutlinedInput-notchedOutline'
            );
            if (notchedOutline) {
              notchedOutline.style.borderWidth = '1.5px';
              notchedOutline.style.borderColor = ERROR;

              // Add an event listener to reset the border color to PRIMARY when input is valid
              element?.addEventListener('input', () => {
                if ((element as HTMLInputElement)?.value?.trim() !== '') {
                  notchedOutline.style.borderColor = ''; // Reset to default (PRIMARY)
                }
              });

              element?.addEventListener('blur', () => {
                if ((element as HTMLSelectElement)?.value?.trim() !== '') {
                  notchedOutline.style.borderColor = '';
                  // notchedOutline.style.borderWidth = '1.5px'; // Reset to default (PRIMARY)
                }
              });
            }
          }
        }
      }
    }
    return isValid;
  }

  return { validateField };
};

export default useValidation;
